import { Badge, Button, Icon } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { AddTagModal } from '@hero/components/modals';
import { NON_EDITABLE_AUTOMATION_STATUS } from '@hero/constants';
import { useGetTagBasedAutomationRecipient } from '@hero/hooks';
import { DetailItem } from '@hero/molecules';
import { BasicContactTable } from '@hero/organisms';

const BadgeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

function WithTags({ automation, onUpdate }) {
  const { t } = useTranslation();
  const [isTagEditOpen, setIsTagEditOpen] = useState(false);

  const isDetailItemEditable = React.useMemo(
    () => !NON_EDITABLE_AUTOMATION_STATUS.includes(automation?.status),
    [automation]
  );

  const { contacts, tagContacts, contactIDList } = useGetTagBasedAutomationRecipient(automation);
  const totalContactCount = contacts?.docs?.length || 0;

  return (
    <>
      <DetailItem title={`${t('tags')}: `} titleStyle={{ width: 100 }} className="item-d-flex">
        <BadgeWrapper>
          {automation?.contacts?.tags?.length > 0 &&
            tagContacts?.docs?.map(tag => (
              <Badge
                key={tag.id}
                variant="contained"
                color="bgWeak"
                rounded
                text={`${tag.name} (${tag.contactsCount})`}
              />
            ))}
        </BadgeWrapper>
        {isDetailItemEditable && (
          <Button variant="link" onClick={() => setIsTagEditOpen(true)}>
            <Icon name="edit" px={14} color="var(--color-accent-primary-default)" />
            {t('editTags')}
          </Button>
        )}
      </DetailItem>
      <DetailItem
        title={`${t('recipients')}: `}
        titleStyle={{ width: 100 }}
        className="item-d-flex"
      >
        {totalContactCount}
      </DetailItem>
      {automation?.contacts?.tags?.length > 0 && (
        <BasicContactTable
          ids={contactIDList}
          disabledColumns={[automation?.type === 'birthday' ? 'anniversary' : 'birthday']}
        />
      )}

      {isTagEditOpen && (
        <AddTagModal
          openModal={isTagEditOpen}
          onRequestClose={() => setIsTagEditOpen(false)}
          ids={automation?.contacts?.tags}
          onUpdate={async selectedRows => {
            const tags = Object.keys(selectedRows);
            await onUpdate({
              params: { code: automation?.code },
              body: {
                contacts: {
                  tags
                }
              }
            });
            setIsTagEditOpen(false);
          }}
        />
      )}
    </>
  );
}

WithTags.propTypes = PropTypes.shape({
  automation: PropTypes.object,
  onUpdate: PropTypes.func
});

export { WithTags };
